/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Perp, PerpInterface } from '../Perp'

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'assetId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int24',
        name: 'tickLower',
        type: 'int24'
      },
      {
        indexed: false,
        internalType: 'int24',
        name: 'tickUpper',
        type: 'int24'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'profit',
        type: 'int256'
      }
    ],
    name: 'Rebalanced',
    type: 'event'
  }
]

const _bytecode =
  '0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212200824694821c56139635b084ca2277bfc345631b3284267b0325c5ed907ff42a264736f6c63430008130033'

export class Perp__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Perp> {
    return super.deploy(overrides || {}) as Promise<Perp>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): Perp {
    return super.attach(address) as Perp
  }
  connect(signer: Signer): Perp__factory {
    return super.connect(signer) as Perp__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PerpInterface {
    return new utils.Interface(_abi) as PerpInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Perp {
    return new Contract(address, _abi, signerOrProvider) as Perp
  }
}
